import { Link } from 'react-router-dom';

export default function PopularRoutes() {
  const routes = [
    {
      title: 'Taxi Utrecht – Schiphol',
      url: '/taxi-utrecht-schiphol',
      icon: 'ri-plane-line'
    },
    {
      title: 'Taxi Utrecht – Eindhoven Airport',
      url: '/taxi-utrecht-eindhoven-airport',
      icon: 'ri-plane-line'
    },
    {
      title: 'Taxi Utrecht – Rotterdam The Hague Airport',
      url: '/taxi-utrecht-rotterdam-airport',
      icon: 'ri-plane-line'
    },
    {
      title: 'Taxi Utrecht – Brussels Airport',
      url: '#',
      icon: 'ri-plane-line'
    }
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Populaire airport taxi routes vanuit Utrecht
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Kies uw bestemming en ontdek meer over onze betrouwbare taxiservice
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {routes.map((route, index) => (
            <Link
              key={index}
              to={route.url}
              className="bg-white rounded-xl p-6 hover:shadow-xl transition-all hover:-translate-y-1 border border-slate-200 cursor-pointer group"
            >
              <div className="w-14 h-14 bg-amber-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-amber-500 transition-colors">
                <i className={`${route.icon} text-2xl text-amber-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-amber-600 transition-colors">
                {route.title}
              </h3>
              <div className="flex items-center text-amber-600 font-semibold">
                <span className="text-sm">Meer informatie</span>
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
